import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue, } from '@/components/ui/select';
import { Folder } from 'lucide-react';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
const ROOT_VALUE = '__root__';
function FolderSelectItems({ nodes, depth = 0 }) {
    return nodes.map((node) => (_jsxs(Fragment, { children: [_jsx(SelectItem, { value: node.id, children: _jsxs("span", { style: { paddingLeft: `${depth * 12}px` }, className: "flex items-center gap-2", children: [_jsx(Folder, { className: "text-muted-foreground h-3.5 w-3.5" }), node.name] }) }), _jsx(FolderSelectItems, { nodes: node.children, depth: depth + 1 })] }, node.id)));
}
export function FolderSelector({ folders, value, onChange, placeholder, disabled = false, allowRoot = true, id, }) {
    const { t } = useTranslation();
    const resolvedPlaceholder = placeholder ?? t('folder.selectParentFolder');
    // Build a flat map of all folders for lookup
    const folderMap = new Map();
    function buildMap(nodes) {
        for (const node of nodes) {
            folderMap.set(node.id, node);
            buildMap(node.children);
        }
    }
    buildMap(folders.personal);
    buildMap(folders.clinic);
    const handleValueChange = (newValue) => {
        if (newValue === ROOT_VALUE) {
            onChange(null, null);
        }
        else {
            const folder = folderMap.get(newValue) || null;
            onChange(newValue, folder);
        }
    };
    const hasPersonal = folders.personal.length > 0;
    const hasClinic = folders.clinic.length > 0;
    return (_jsxs(Select, { value: value ?? (allowRoot ? ROOT_VALUE : ''), onValueChange: handleValueChange, disabled: disabled, children: [_jsx(SelectTrigger, { id: id, children: _jsx(SelectValue, { placeholder: resolvedPlaceholder }) }), _jsxs(SelectContent, { children: [allowRoot && (_jsx(SelectItem, { value: ROOT_VALUE, children: _jsx("span", { className: "text-muted-foreground", children: t('folder.noneCreateAtRoot') }) })), hasPersonal && (_jsxs(SelectGroup, { children: [_jsx(SelectLabel, { children: t('folder.myFolders') }), _jsx(FolderSelectItems, { nodes: folders.personal })] })), hasClinic && (_jsxs(SelectGroup, { children: [_jsx(SelectLabel, { children: t('folder.clinicFolders') }), _jsx(FolderSelectItems, { nodes: folders.clinic })] }))] })] }));
}
